import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { darkThemeHeaderVars, lightThemeHeaderVars } from './GlobalHeader.palette';

export const snapGlobalHeaderPrimaryVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...lightThemeHeaderVars,
  '--global-header-bg-color': m('--neutral-v0'),
  '--global-header-border-color': m('--neutral-v700'),
  '--global-header-menu-item-bg-hover-color': m('--neutral-v100'),
  '--global-header-menu-border-color': m('--neutral-v100'),
  '--global-header-menu-border-radius': '0px',
  '--global-header-menu-box-shadow': '0 4px 8px 0 rgba(0, 0, 0, 0.06)',
  '--global-header-menu-item-border-radius': '0px',
  '--global-header-menu-featured-item-bg-color': m('--neutral-v150'),
  '--global-header-menu-featured-item-bg-hover-color': m('--neutral-v200'),
  '--global-header-menu-featured-item-border-radius': '0px',
  '--global-header-nav-screen-global-links-bg-color': m('--neutral-v0'),
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-desktop-font-text-transform': 'none',
  '--global-header-navigator-item-mobile-font-text-transform': 'none',
} as const;

export const snapGlobalHeaderSecondaryVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...darkThemeHeaderVars,
  '--global-header-bg-color': m('--neutral-v700'),
  '--global-header-border-color': m('--neutral-v0'),
  '--global-header-fg-color': m('--neutral-v300'),
  '--global-header-menu-border-color': m('--neutral-v625'),
  '--global-header-menu-border-radius': '0px',
  '--global-header-menu-box-shadow': '0 4px 8px 0 rgba(0, 0, 0, 0.06)',
  '--global-header-menu-featured-item-bg-color': m('--neutral-v600'),
  '--global-header-menu-featured-item-bg-hover-color': m('--neutral-v625'),
  '--global-header-menu-featured-item-border-radius': '0px',
  '--global-header-menu-item-bg-hover-color': m('--neutral-v625'),
  '--global-header-menu-item-border-radius': '0px',
  '--global-header-nav-screen-bg-color': m('--neutral-v700'),
  '--global-header-nav-screen-fg-color': m('--neutral-v300'),
  '--global-header-nav-screen-global-links-bg-color': m('--neutral-v650'),
  '--global-header-navigator-item-desktop-font-text-transform': 'none',
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-mobile-font-text-transform': 'none',
} as const;
